<div
  *renderingPermissionDirective="[
    'DeviceMonitoringWriter',
    'DeviceMonitoringReader',
    'DeviceMonitoringAdmin',
  ]"
  class="state">
  <dcc-page-title title="Insights"></dcc-page-title>
  <dcc-tabbed-navigation></dcc-tabbed-navigation>
  <router-outlet></router-outlet>
</div>
